export const envUrl = () => {
  let url

  switch (process.env.NODE_ENV) {
    case 'production':
      url = '.fagbokforlaget.no'
      break
    case 'stage':
      url = '.stage.student.forlagshuset.no'
      break
    case 'development':
      url = '.dev.student.forlagshuset.no'
      break
    case 'local':
      url = '.' + window.location.host.split('.').splice(1).join('.')
      break
    default:
  }

  return url
}
